import React, { useState, useEffect } from 'react';
import { useAppContext } from '../context/AppContext';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const TravelAccommodation = () => {
  const { t } = useTranslation();
  const { wedding, setWedding } = useAppContext();
  const [type, setType] = useState('hotel');
  const [name, setName] = useState('');
  const [info, setInfo] = useState('');
  const [link, setLink] = useState('');
  const [travelAccommodations, setTravelAccommodations] = useState([]);
  const cardId = localStorage.getItem('id');
  const apiUrl = process.env.REACT_APP_API_BASE_URL + '/planner/travel-accommodation';


  useEffect(() => {
    const fetchTravelAccommodations = async () => {
      try {
        const response = await axios.get(apiUrl, { params: { card_id: cardId } });
        setTravelAccommodations(response.data);
      } catch (error) {
        console.error("Error fetching travel accommodations:", error);
      }
    };

    if (cardId) {
      fetchTravelAccommodations();
    }
  }, [cardId, apiUrl]);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (name.trim()) {
      try {
        const response = await axios.post(apiUrl, { card_id: cardId, type, name, info, link });
        setTravelAccommodations([...travelAccommodations, response.data.data]);
        setName('');
        setInfo('');
        setLink('');
      } catch (error) {
        console.error("Error adding travel accommodation:", error);
        // Handle error appropriately, e.g., display an error message
      }
    }
  };

  const handleRemove = async (id) => {
    try {
      await axios.delete(`${apiUrl}/${id}`);
      setTravelAccommodations(travelAccommodations.filter((item) => item.id !== id));
    } catch (error) {
      console.error("Error removing travel accommodation:", error);
      // Handle error appropriately
    }
  };

  const handleClearData = async () => {
    if (window.confirm(t('travelAccommodation.clearDataConfirmation'))) {
      try {
        await axios.get(apiUrl, { params: { card_id: cardId } }).then(res => {
          res.data.forEach(async (item) => {
            await axios.delete(`${apiUrl}/${item.id}`);
          });
        });
        setTravelAccommodations([]);
      } catch (error) {
        console.error("Error clearing travel accommodations:", error);
        // Handle error appropriately
      }
    }
  };

  return (
    <div className="max-w-4xl mx-auto py-10 px-2">
      <h1 className="text-3xl font-bold text-primary mb-2">{t('travelAccommodation.title')}</h1>
      <p className="text-foreground/70 mb-2">{t('travelAccommodation.description')}</p>
      <p className="text-sm text-foreground/50 mb-6 italic">
        {t('travelAccommodation.sampleDataNote')}
      </p>

      <div className="flex flex-wrap md:flex-nowrap items-start justify-between gap-4 mb-6">
      <form className="flex flex-wrap gap-3 flex-1 min-w-0" onSubmit={handleAdd}>
        <select
          className="border rounded px-3 py-2 w-full sm:w-auto"
          value={type}
          onChange={e => setType(e.target.value)}
        >
          <option value="hotel">{t('travelAccommodation.typeHotel')}</option>
          <option value="transport">{t('travelAccommodation.typeTransport')}</option>
          <option value="tip">{t('travelAccommodation.typeTip')}</option>
        </select>
        <input
          type="text"
          className="border rounded px-3 py-2 flex-1 min-w-[150px]"
          placeholder={t('travelAccommodation.namePlaceholder')}
          value={name}
          onChange={e => setName(e.target.value)}
          required
        />
        <input
          type="text"
          className="border rounded px-3 py-2 flex-1 min-w-[150px]"
          placeholder={t('travelAccommodation.infoPlaceholder')}
          value={info}
          onChange={e => setInfo(e.target.value)}
        />
        <input
          type="text"
          className="border rounded px-3 py-2 flex-1 min-w-[150px]"
          placeholder={t('travelAccommodation.linkPlaceholder')}
          value={link}
          onChange={e => setLink(e.target.value)}
        />
        <button
          type="submit"
          className="bg-primary text-white px-4 py-2 rounded hover:bg-secondary hover:text-gray-800 transition-colors w-full sm:w-auto"
        >
          {t('common.add')}
        </button>
      </form>

      <button
        onClick={handleClearData}
        className="bg-danger text-white px-4 py-2 rounded hover:bg-secondary hover:text-gray-800 transition-colors w-full md:w-auto"
        disabled={travelAccommodations.length === 0}
      >
        {t('travelAccommodation.clearAllData')}
      </button>
      </div>

      <div className="space-y-4">
        {travelAccommodations.length === 0 && (
          <div className="text-foreground/50">{t('travelAccommodation.noInfoAddedYet')}</div>
        )}
        {travelAccommodations.map((item) => (
          <div key={item.id} className="bg-white rounded shadow p-4 flex flex-col md:flex-row md:items-center gap-3">
            <span
              className={`font-bold ${
                item.type === 'hotel'
                  ? 'text-primary'
                  : item.type === 'transport'
                  ? 'text-info'
                  : 'text-accent'
              }`}
            >
              {item.type.charAt(0).toUpperCase() + item.type.slice(1)}
            </span>
            <span className="font-semibold flex-1">{item.name}</span>
            {item.info && <span className="flex-1">{item.info}</span>}
            {item.link && (
              <a
                href={item.link}
                className="text-info underline flex-1"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('travelAccommodation.linkText')}
              </a>
            )}
            <button onClick={() => handleRemove(item.id)} className="text-danger px-2">
              {t('common.remove')}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TravelAccommodation;
